/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Ezatullah Rafie',
        title: 'Control Systems UX\UI Developer at Tigercat Industries Inc.',
        text: "I've had the privilege of working with Ilshin Ji on various projects, and her outstanding coding, documentation, and teamwork skills have consistently contributed to our success.",
        image: boy2
    },
    {
        id: 2,
        name: 'Stefan Kovacevic',
        title: 'Software Developer at Brock Solutions',
        text: "Ilshin is a highly skilled programmer, whose positivity and uplifting attitude make her not only a great student but also a fantastic team player, inspiring everyone around her.",
        image: boy1
    },
    {
        id: 3,
        name: 'Trevor White',
        title: 'Systems Developer at Co-operators',
        text: "Ilshin is an awesome team member and is great to work with. Best of all, she actually knows how to code very well and any programming she doesn't know she goes out and learns which is something not everyone can do.",
        image: boy3
    },
    // {
    //     id: 4,
    //     name: 'Joey Tribbiani',
    //     title: 'Actor',
    //     text: "Making my portfolio with this helped me get my role as 'Dr. Drake Ramoray' in 'Days Of Our Lives'. You guys are the best !",
    //     image: boy1
    // },
    // {
    //     id: 5,
    //     name: 'Rachel Green',
    //     title: 'Sales Executive',
    //     text: 'Ralph Lauren was one of the best things that ever happened to me. My portfolio made that dream happen. I owe you guys.',
    //     image: girl3
    // },
    // {
    //     id: 6,
    //     name: 'Ross Geller',
    //     title: 'Paleontologist',
    //     text: "Be it 'Rocks' or 'Bones', you need a website to display it. This is it. Great work guys !",
    //     image: boy3
    // }
]

